import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewTestimonial.module.scss';
import {
    ALIGNMENT_OPTIONS,
    HEADING_LEVELS,
    HEADING_STYLES,
    BREAKPOINT_MOBILE,
} from '../../lib/constants';

import useBreakpoint from '../../lib/helpers/useBreakpoint';

import { Carousel } from '../_shared';
import { Heading, Text } from '../index';

const NewTestimonial = (props) => {
    const { headlineText, headingLevel, headingStyle, headingAlignment, items } = props;

    const currentBreakpoint = useBreakpoint();
    const isMobile = currentBreakpoint === BREAKPOINT_MOBILE;

    return (
        <div className={styles['new-testimonial']}>
            <Heading
                text={headlineText}
                alignment={headingAlignment}
                overrideStyle={!isMobile ? headingStyle : 'h3'}
                headingLevel={headingLevel}
                className={styles['new-testimonial__heading']}
            />
            <Carousel loop slides={1} className="new-testimonial-carousel">
                {items.map((item, index) => (
                    <div
                        className={styles['new-testimonial__carousel-slide']}
                        key={`new-testimonial-${index}`}
                    >
                        <Text
                            content={item.testimonial}
                            className={styles['new-testimonial__testimonial']}
                        />
                        <Text content={item.subtext} />
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

NewTestimonial.displayName = 'NewTestimonial';

NewTestimonial.propTypes = {
    headlineText: PropTypes.string.isRequired,
    headingAlignment: PropTypes.oneOf(ALIGNMENT_OPTIONS),
    headingLevel: PropTypes.oneOf(HEADING_LEVELS),
    headingStyle: PropTypes.oneOf(HEADING_STYLES),
    items: PropTypes.arrayOf(
        PropTypes.shape({
            testimonial: PropTypes.string.isRequired,
            subtext: PropTypes.string.isRequired,
        })
    ),
};

export default NewTestimonial;
